export default __webpack_public_path__ + "static/media/shop-icon.c5620f09.svg";